export function isServerMessage(message) {
    return Number.isSafeInteger(message?.id) && message.id > 0
        && Number.isSafeInteger(message.sequence) && message.sequence > 0
        && !message.pending && !message.send_error;
}

export function highestServerSequence(messages) {
    return messages.reduce((highest, message) => isServerMessage(message) ? Math.max(highest, message.sequence) : highest, 0);
}

export function postingBlockedMessage(conversation) {
    if (conversation?.can_post === true && !conversation.archived_at) return '';
    if (conversation?.archived_at || conversation?.post_blocked_reason === 'ARCHIVED') return 'This conversation is archived and read-only.';
    if (conversation?.post_blocked_reason === 'LEGACY_CHANNEL') return 'Historical channel — read-only. Open the current channel from the Job to send a message.';
    if (conversation?.can_post === false) return 'You do not have permission to send messages in this conversation. Contact an administrator for access.';
    return 'Sending permissions unavailable. Refresh the conversation to try again.';
}
